import React from 'react';

const faqs = [
  {
    question: "What makes a good sports team name?",
    answer: "A good sports team name should be memorable, reflect your team's values, and resonate with your players and fans. Consider incorporating elements like your location, sport-specific terms, or team characteristics."
  },
  {
    question: "How do you create a unique team name?",
    answer: "To create a unique team name, combine elements like your location, team values, and distinctive characteristics. Our generator helps by combining these elements with sport-specific terms and popular naming patterns."
  },
  {
    question: "What are popular themes for team names?",
    answer: "Popular themes include animals (Lions, Eagles), weather phenomena (Thunder, Storm), powerful entities (Titans, Warriors), and location-based names (City United, Metro Knights)."
  },
  {
    question: "Should my team name be serious or fun?",
    answer: "This depends on your team's level and context. Professional teams typically choose more serious names, while recreational teams might opt for more creative or fun names. Consider your audience and level of competition."
  },
  {
    question: "Can I use my generated team name commercially?",
    answer: "Yes, the names generated are free to use. However, we recommend checking for existing trademarks if you plan to use the name commercially, especially for professional teams."
  },
  {
    question: "How often are new names added to the generator?",
    answer: "Our AI system continuously learns from current sports trends and user preferences to expand its name generation capabilities, ensuring fresh and relevant suggestions."
  }
];

export default function SportsTeamFAQ() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">
          Sports Team Names FAQ
        </h2>
        
        <div className="space-y-8">
          {faqs.map((faq, index) => (
            <div key={index} className="bg-indigo-50 p-6 rounded-lg transform transition-all duration-300 hover:scale-[1.02]">
              <h3 className="text-lg font-semibold text-gray-900 mb-2">
                {faq.question}
              </h3>
              <p className="text-gray-600">{faq.answer}</p>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center text-sm text-indigo-600">
          <p>Don't see your question? Contact our support team for more information.</p>
        </div>
      </div>
    </section>
  );
}